module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_16_9_w_768.5f28850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_768.jpg
// module id = ITUe
// module chunks = 0